<template>
  <div class="container">
    <div class="fixed">
      <div class="popup_header1 container align-horizontal" style="width: 1070px;">
        <span style="margin: auto">{{$t('more.notify_list')}}</span>
        <h1 style="margin: 0; color: gray"
            @click="()=>{
        this.$store.commit('setTodayNotifyList', false);
        this.$router.push('/home');
      }"
        ><b-icon icon="x"></b-icon></h1>
      </div>
    </div>
    <div style="padding: 3em 0 6em 0; margin-top: 20px;">
      <NotifyItem
        v-for="(item, i) in dataList"
        :key="i"
        :item="item"
        @click="onNotifyClick(i, item.f_idx)"
        @longClick="onNotifyLongClick(i)"
        @deleteAuto="onDeleteAuto"
        style="margin-left: 1em; margin-right: 1em;"
        :is-auto="tabIndex + 1 == $c.NOTIFY_TAB.AUTO"
        :auto-index="i + 1"
      />
    </div>
    <Navbar :bar-visible="!$store.getters.getForceHideMainBottomBar">
      <SearchForm
        :searchValue.sync="keyword"
        :searchType.sync="searchType"
        :count="pageCnt"
        :hide-read-all="false"
        @change_page="change_page"
        @search="type_search"
        @delete="onDelete"
        @check="onCheckAll"
        @readAll="onReadAll"
        :is-all-read="this.dataList.some(it => {return it.f_read == 'N'})"
        variant="today"
      ></SearchForm>
    </Navbar>
    <NotifyWritePopup
      v-if="showCreate"
      :is-auto="tabIndex == $c.NOTIFY_TAB.AUTO - 1? 'Y' : 'N'"
      :visible.sync="showCreate"
      :info="notifySelected"
      @move="(val) =>{
        self.tabIndex = val-1;
        self.getList();
      }"
      @save="getList(); $refs.createItem.init();" />
    <NotifyDetailPopup
      v-if="showDetail"
      :visible.sync="showDetail"
      :item="notifySelected" />
  </div>
</template>

<script>
import Utils from "../../../../config/utils";
import Navbar from "../../../controls/navbar";
import SearchForm from "../admin/controls/search_form";
import NotifyWritePopup from "../../../controls/popup/NotifyWritePopup";
import NotifyItem from "../../../controls/NotifyItem";
import NotifyDetailPopup from "../../../controls/popup/NotifyDetailPopup";

const u = require('util');

const SEARCH_COLUMN = [
  'f_title',
  'f_content',
  'f_title_content',
  'f_site_name',
  'f_contact',
];

export default {
  name: "TodayNotify",
  components: {
    SearchForm,
    Navbar,
    NotifyWritePopup,
    NotifyItem,
    NotifyDetailPopup
  },
  data() {
    return {
      self:this,
      ut: u,
      u:Utils,
      tabIndex:1,
      dataList:[],
      pageCnt:1,
      totalCnt:1,
      limit:0,
      searchType:null,
      keyword:null,
      currentPage:1,
      notifySelected:null,
      showDetail:false,
      showCreate:false,
      pageTitle:'',
    }
  },
  inject:["eventBus"],

  methods:{
    onReadAll() {
      Utils.requestPost(
        this.$c.API.Notify.setRead,
        { notify_idx: 0 },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.getList();
        } else {
          Utils.toast(result.msg);
        }
      });
    },
    onCreate() {
      this.notifySelected = null;
      this.showCreate = true;
    },

    onCheckAll(state){
      this.dataList = this.dataList.map(it => {
        it.f_select = state;
        return it;
      });
    },

    onNotifyClick(index, item_idx) {
        if (this.dataList[index].f_read == 'N') {
          Utils.requestPost(
            this.$c.API.Notify.setRead,
            {
              notify_idx: this.dataList[index].f_idx,
            },
          ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.setState(this,{
                showDetail: true,
                notifySelected: this.dataList[index],
                dataList: this.dataList.map((it, idx) => {
                  if (index == idx) {
                    it.f_read = 'Y';
                  }
                  return it;
                })
              });
            } else {
              Utils.toast(this, result.msg);
            }
          });
        } else {
          Utils.setState(this, {
            notifySelected: this.dataList[index],
            showDetail: true,
          });
        }
    },

    onNotifyLongClick(index){
      if (this.tabIndex != this.$c.NOTIFY_TAB.AUTO -1)
      this.dataList = this.dataList.map((it, idx) => {
        if (index == idx) {
          it.f_select = true;
        }
        return it;
      });
    },

    onDeleteAuto(index){
      this.dataList = this.dataList.filter((it, idx) => {
        if (index != idx) {
          return it;
        }
      });
    },

    onDelete(){
      let self = this;
      let selectList = this.dataList.filter(it => {
        return it.f_select;
      }).map(it => {
          return it.f_idx;
        },
      );
      if (selectList.length < 1) {
        return;
      }
        Utils.showConfirm(
          this,
          this.$t("notify.delete_confirm")
        ).then(
          value =>{
            if (value){
              Utils.requestPost(
                this.$c.API.Notify.removeNotify,
                {
                  idx_list: JSON.stringify(selectList),
                },
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  Utils.toast(this, this.$t("common.delete_success"));
                  this.getList();
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            }
          }
        );
    },

    change_page(page){
      this.currentPage = page;
      this.getList();
    },

    type_search(){
      this.getList();
    },

    getList(){
      this.dataList = [];
      let url = this.$c.API.Notify.getNotifyList
      Utils.requestGet( url,
        {
          site_idx: this.$store.getters.getSiteForNotifyList,
          page_num: this.currentPage,
          column: this.searchType,
          keyword: this.searchType == SEARCH_COLUMN[4] ? this.keyword.replaceAll('-', '') : this.keyword,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.totalCnt = result.data.total;
            this.pageCnt = result.data.page_count;
            this.limit = result.data.limit;
            this.pageNum += 1;
            this.dataList = result.data.list.map(it => {
              it.f_select = false;
              return it;
            });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },

  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.HOME);
    this.getList();
  },
}
</script>

<style lang="scss">
@import '../../../../assets/css/_vars.scss';
.no_item {
  color: $text;
  font-size: $fs_20;
  font-family: $korean_gd_13_r;
  margin-top: 200px;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/notify/TodayNotify.vue